import React from 'react';
import { Link } from 'react-router-dom';
import { TargetIcon, SparklesIcon, ZapIcon, LayersIcon, TrendingUpIcon, CheckCircleIcon, ArrowRightIcon, UsersIcon, PlayIcon } from 'lucide-react';
export function GTMStudioPage() {
  return <div className="w-full bg-white" data-id="element-7194">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-900 via-teal-800 to-green-900 text-white py-24 overflow-hidden" data-id="element-7195">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-7196" />
        <div className="absolute inset-0" data-id="element-7197">
          <div className="absolute top-20 left-10 w-72 h-72 bg-teal-500/20 rounded-full blur-3xl animate-pulse" data-id="element-7198" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-7199" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-7200">
          <div className="max-w-4xl mx-auto text-center" data-id="element-7201">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-500/20 rounded-full border border-teal-400/30 mb-6" data-id="element-7202">
              <TargetIcon className="w-4 h-4" data-id="element-7203" />
              <span className="text-sm font-medium" data-id="element-7204">
                GTM Planning & Execution
              </span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-7205">
              GTM Studio
            </h1>
            <p className="text-xl text-teal-100 mb-8 leading-relaxed" data-id="element-7206">
              The workspace where marketing, sales, CS, and RevOps teams plan,
              build, and launch GTM plays in minutes — not weeks.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-7207">
              <Link to="/signup" className="px-8 py-4 bg-white text-teal-900 rounded-lg hover:bg-teal-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-7208">
                Start Building
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7209">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* What Studio Does */}
      <section className="py-24 bg-white" data-id="element-7210">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7211">
          <div className="text-center mb-16" data-id="element-7212">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7213">
              What GTM Studio does
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-7214">
              Studio is where you define target segments, select plays, generate
              assets, and launch campaigns across every GTM system.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-7215">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-xl p-8 border-2 border-teal-200" data-id="element-7216">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7217">
                <TargetIcon className="w-8 h-8 text-white" data-id="element-7218" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7219">
                Build segments
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7220">
                Use AI or visual query builder to create target account lists
                from ZoomInfo data, CRM, and product signals.
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 border-2 border-blue-200" data-id="element-7221">
              <div className="w-16 h-16 bg-blue-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7222">
                <PlayIcon className="w-8 h-8 text-white" data-id="element-7223" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7224">
                Select plays
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7225">
                Choose from the GTM library or import custom plays. Studio shows
                eligibility and estimated impact.
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 border-2 border-purple-200" data-id="element-7226">
              <div className="w-16 h-16 bg-purple-600 rounded-xl flex items-center justify-center mb-6" data-id="element-7227">
                <ZapIcon className="w-8 h-8 text-white" data-id="element-7228" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-7229">
                Launch everywhere
              </h3>
              <p className="text-gray-700 leading-relaxed" data-id="element-7230">
                Publish to Copilot, Orchestration, marketing automation, sales
                engagement, and partner portals.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Key Features */}
      <section className="py-24 bg-gray-50" data-id="element-7231">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7232">
          <div className="text-center mb-16" data-id="element-7233">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7234">
              Studio features
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-7235">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7236">
              <div className="flex items-center gap-3 mb-4" data-id="element-7237">
                <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center" data-id="element-7238">
                  <SparklesIcon className="w-6 h-6 text-white" data-id="element-7239" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7240">
                  AI segment builder
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7241">
                Describe your target in natural language. Studio queries
                ZoomInfo, CRM, and product data to build the list.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7242">
                <span className="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm" data-id="element-7243">
                  Natural language
                </span>
                <span className="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm" data-id="element-7244">
                  Multi-source
                </span>
                <span className="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-sm" data-id="element-7245">
                  Real-time
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7246">
              <div className="flex items-center gap-3 mb-4" data-id="element-7247">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-7248">
                  <LayersIcon className="w-6 h-6 text-white" data-id="element-7249" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7250">
                  Visual query builder
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7251">
                Drag-and-drop filters for firmographics, technographics, intent,
                and behavioral signals. No SQL needed.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7252">
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-7253">
                  No-code
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-7254">
                  Complex logic
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-7255">
                  Live preview
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7256">
              <div className="flex items-center gap-3 mb-4" data-id="element-7257">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-7258">
                  <PlayIcon className="w-6 h-6 text-white" data-id="element-7259" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7260">
                  Play templates
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7261">
                Import pre-built plays from the GTM library. Studio
                auto-configures channels, touchpoints, and assets.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7262">
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7263">
                  15+ plays
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7264">
                  Auto-config
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-7265">
                  Customizable
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-7266">
              <div className="flex items-center gap-3 mb-4" data-id="element-7267">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center" data-id="element-7268">
                  <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-7269" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-7270">
                  Impact forecasting
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-7271">
                See estimated meetings, pipeline, and ROI before you launch.
                Based on historical play performance.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-7272">
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7273">
                  Pre-launch estimates
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7274">
                  Historical data
                </span>
                <span className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm" data-id="element-7275">
                  ROI calc
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Workflow */}
      <section className="py-24 bg-white" data-id="element-7276">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7277">
          <div className="text-center mb-16" data-id="element-7278">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7279">
              How Studio works
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-7280">
            <div className="text-center" data-id="element-7281">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7282">
                <span className="text-2xl font-bold text-white" data-id="element-7283">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7284">
                Define segment
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7285">
                Use AI or visual builder to create your target account list
              </p>
            </div>
            <div className="text-center" data-id="element-7286">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7287">
                <span className="text-2xl font-bold text-white" data-id="element-7288">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7289">
                Pick a play
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7290">
                Browse library or import custom play template
              </p>
            </div>
            <div className="text-center" data-id="element-7291">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7292">
                <span className="text-2xl font-bold text-white" data-id="element-7293">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7294">
                Generate assets
              </h3>
              <p className="text-sm text-gray-600" data-id="element-7295">
                AI creates emails, scripts, and content
              </p>
            </div>
            <div className="text-center" data-id="element-7296">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-7297">
                <span className="text-2xl font-bold text-white" data-id="element-7298">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7299">Launch</h3>
              <p className="text-sm text-gray-600" data-id="element-7300">
                Publish to Copilot, Orchestration, and GTM systems
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Use Cases */}
      <section className="py-24 bg-gray-50" data-id="element-7301">
        <div className="max-w-7xl mx-auto px-6" data-id="element-7302">
          <div className="text-center mb-16" data-id="element-7303">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-7304">
              Who uses Studio
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-7305">
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-teal-300 hover:shadow-lg transition-all" data-id="element-7306">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7307">
                Marketing teams
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7308">
                For campaign planning, ABM programs, and event follow-up that
                connects to sales execution.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-teal-300 hover:shadow-lg transition-all" data-id="element-7309">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7310">
                RevOps teams
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7311">
                For GTM planning, play design, and cross-functional
                orchestration across marketing, sales, and CS.
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-teal-300 hover:shadow-lg transition-all" data-id="element-7312">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7313">
                Sales leaders
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-7314">
                For territory planning, account prioritization, and ensuring
                reps work the right accounts.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-teal-600 to-green-700 text-white" data-id="element-7315">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7316">
          <h2 className="text-4xl font-bold mb-6" data-id="element-7317">
            Ready to plan and launch GTM plays faster?
          </h2>
          <p className="text-xl text-teal-100 mb-8" data-id="element-7318">
            Start building in GTM Studio today
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-7319">
            <Link to="/signup" className="px-8 py-4 bg-white text-teal-600 rounded-lg hover:bg-teal-50 font-medium text-lg shadow-lg" data-id="element-7320">
              Get Started
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-7321">
              Schedule Demo
            </Link>
          </div>
        </div>
      </section>
    </div>;
}